export enum ClaimPriorityCode {
  Normal = 'claim.priority.normal',
}

/**
 * The `CareAtHome` claim has been removed for now because it currently not used
 */
export enum ClaimTypeCode {
  HospitalAtHome = 'claim.type.hospitalathome',
  TCP = 'claim.type.tcp',
  RemotePatientMonitoring = 'claim.type.remotepatientmonitoring',
  HealingHands = 'claim.type.healinghands',
  Arthroplasty = 'claim.type.arthroplasty',
  InHospitalMonitoring = 'claim.type.inhospitalmonitoring',
  HospitalAtHomeUpgrade = 'claim.type.hospitalathome.upgrade',
  SPHERE = 'claim.type.sphere',
}
